<div class="register-container">
  <div class="register-form">
    <h2>Crie sua Conta</h2>

    <!-- Indicador de progresso -->
    <div class="progress-indicator">
      <div class="step" [class.active]="step === 1">1</div>
      <div class="progress-line"></div>
      <div class="step" [class.active]="step === 2">2</div>
    </div>

    <!-- Etapa 1: Dados principais -->
    <div *ngIf="step === 1" class="step-content">
      <h3>Dados da Empresa</h3>

      <form [formGroup]="registerForm">
        <div class="form-group">
          <label for="email">Email</label>
          <input id="email" type="email" formControlName="email"
                 [class.is-invalid]="registerForm.get('email')?.invalid && registerForm.get('email')?.touched">
          <div *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched" class="invalid-feedback">
            <div *ngIf="registerForm.get('email')?.errors?.['required']">Email é obrigatório.</div>
            <div *ngIf="registerForm.get('email')?.errors?.['email']">Formato de email inválido.</div>
          </div>
        </div>


        <div class="form-row">
          <div class="form-group">
            <label for="cnpj">CNPJ</label>
            <input id="cnpj" type="text" formControlName="cnpj" mask="00.000.000/0000-00"
                   [class.is-invalid]="registerForm.get('cnpj')?.invalid && registerForm.get('cnpj')?.touched">
            <div *ngIf="registerForm.get('cnpj')?.invalid && registerForm.get('cnpj')?.touched" class="invalid-feedback">
              <div *ngIf="registerForm.get('cnpj')?.errors?.['required']">CNPJ é obrigatório.</div>
            </div>
          </div>

          <div class="form-group">
            <label for="name">Nome da Empresa</label>
            <input id="name" type="text" formControlName="name"
                   [class.is-invalid]="registerForm.get('name')?.invalid && registerForm.get('name')?.touched">
            <div *ngIf="registerForm.get('name')?.invalid && registerForm.get('name')?.touched" class="invalid-feedback">
              <div *ngIf="registerForm.get('name')?.errors?.['required']">Nome é obrigatório.</div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="password">Senha</label>
            <input id="password" type="password" formControlName="password"
                   [class.is-invalid]="registerForm.get('password')?.invalid && registerForm.get('password')?.touched">
            <div *ngIf="registerForm.get('password')?.invalid && registerForm.get('password')?.touched" class="invalid-feedback">
              <div *ngIf="registerForm.get('password')?.errors?.['required']">Senha é obrigatória.</div>
              <div *ngIf="registerForm.get('password')?.errors?.['minlength']">Mínimo 6 caracteres.</div>
            </div>
          </div>

          <div class="form-group" [formGroup]="confirmPasswordForm">
            <label for="confirmPassword">Confirmar Senha</label>
            <input id="confirmPassword" type="password" formControlName="confirmPassword"
                   [class.is-invalid]="(confirmPasswordForm.get('confirmPassword')?.touched && !passwordsMatch) ||
                                      (confirmPasswordForm.get('confirmPassword')?.invalid && confirmPasswordForm.get('confirmPassword')?.touched)">
            <div *ngIf="(confirmPasswordForm.get('confirmPassword')?.touched && !passwordsMatch) ||
                        (confirmPasswordForm.get('confirmPassword')?.invalid && confirmPasswordForm.get('confirmPassword')?.touched)"
                 class="invalid-feedback">
              <div *ngIf="confirmPasswordForm.get('confirmPassword')?.errors?.['required']">Confirmação obrigatória.</div>
              <div *ngIf="!passwordsMatch && !confirmPasswordForm.get('confirmPassword')?.errors?.['required']">Senhas não coincidem.</div>
            </div>
          </div>
        </div>
      </form>

      <div class="form-actions">
        <button type="button" class="btn-next" [disabled]="!isStep1Valid" (click)="nextStep()">Próximo</button>
      </div>
    </div>

    <!-- Mensagem de sucesso -->
    <div *ngIf="registrationSuccess" class="success-message">
      <div class="success-icon">✓</div>
      <h3>Cadastro realizado com sucesso!</h3>
      <p>Você será redirecionado para a página de login em instantes...</p>
    </div>

    <!-- Mensagem de erro -->
    <div *ngIf="registrationError" class="error-message">
      <div class="error-icon">✗</div>
      <h3>Erro no cadastro</h3>
      <p>{{ errorMessage }}</p>
      <button type="button" class="btn-close" (click)="dismissError()">Fechar</button>
    </div>

    <!-- Etapa 2: Dados de endereço e contato -->
    <div *ngIf="step === 2 && !registrationSuccess" class="step-content">
      <h3>Dados de Endereço e Contato</h3>

      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-group">
            <label for="phone">Telefone</label>
            <input id="phone" type="text" formControlName="phone" mask="(00) 00000-0000"
                   [class.is-invalid]="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched">
            <div *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched" class="invalid-feedback">
              <div *ngIf="registerForm.get('phone')?.errors?.['required']">Telefone obrigatório.</div>
            </div>
          </div>

          <div class="form-group">
            <label for="postal_code">CEP</label>
            <input id="postal_code" type="text" formControlName="postal_code" mask="00000-000"
                   [class.is-invalid]="registerForm.get('postal_code')?.invalid && registerForm.get('postal_code')?.touched">
            <div *ngIf="registerForm.get('postal_code')?.invalid && registerForm.get('postal_code')?.touched" class="invalid-feedback">
              <div *ngIf="registerForm.get('postal_code')?.errors?.['required']">CEP obrigatório.</div>
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="address_number">Número</label>
            <input id="address_number" type="text" formControlName="address_number"
                   [class.is-invalid]="registerForm.get('address_number')?.invalid && registerForm.get('address_number')?.touched">
            <div *ngIf="registerForm.get('address_number')?.invalid && registerForm.get('address_number')?.touched" class="invalid-feedback">
              <div *ngIf="registerForm.get('address_number')?.errors?.['required']">Número obrigatório.</div>
            </div>
          </div>

          <div class="form-group">
            <label for="complement">Complemento <span class="optional">(opcional)</span></label>
            <input id="complement" type="text" formControlName="complement">
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn-back" (click)="previousStep()" [disabled]="isSubmitting">Voltar</button>
          <button type="submit" class="btn-submit" [disabled]="!isStep2Valid || isSubmitting">
            <span *ngIf="!isSubmitting">Cadastrar</span>
            <span *ngIf="isSubmitting">Processando...</span>
          </button>
        </div>
      </form>
    </div>

    <div class="login-link">
      <p>Já tem uma conta? <a routerLink="/login">Faça o login</a></p>
    </div>
  </div>
</div>
